import * as React from 'react';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import { observer } from 'mobx-react';

import styles from './home-page.less';

import { HomePageContainer } from '../home-page';
import { PageFooterContainer } from '../../page-footer/page-footer';
import { PageError } from '../../page-error/page-error';

interface HomePageContainerProps {
    container: HomePageContainer;
}

export const HomePage = observer<React.SFC<HomePageContainerProps>>(
    ({ container: { balance, jobs, showPayText, errorMessage, clearError } }) => (
        <div className="page">
            <div className="page-topping">
                <PageError message={errorMessage} onClose={clearError} />
            </div>
            <div className={classnames('page-inverted', 'row', styles.row)}>
                <div className={classnames('col', styles.col, styles.balanceCanvas)}>
                    {balance > 0 ? (
                        <div>
                            <img className={classnames(styles.svg, styles.money)} />
                            <NavLink to="/statements" className={classnames(styles.invertedButton)}>
                                <span>{showPayText ? 'Pay' : 'View'} Your Balance</span>
                            </NavLink>
                        </div>
                    ) : null}
                    {balance === 0 ? (
                        <div>
                            <img className={classnames(styles.svg, styles.money)} />
                            <div className={classnames(styles.noValue)}>
                                <p>You have no balance</p>
                                <p>Give yourself a pat on the back</p>
                            </div>
                        </div>
                    ) : null}
                </div>

                <div className={classnames('col', styles.col, styles.historyCanvas)}>
                    {jobs > 0 ? (
                        <div>
                            <img className={classnames(styles.svg, styles.tools)} />
                            <NavLink to="/history" className={classnames(styles.invertedButton)}>
                                <span>View Service History</span>
                            </NavLink>
                        </div>
                    ) : null}
                    {jobs === 0 ? (
                        <div>
                            <img className={classnames(styles.svg, styles.tools)} />
                            <div className={classnames(styles.noValue)}>
                                <p>You have no service history</p>
                                <p>We hope to earn your business soon</p>
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
            <PageFooterContainer />
        </div>
    )
);
